<app-modal #modal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Warning!</h2>
    </div>
    <div class="modal-body">
      <p>Warning! The card in this wallet is already active.</p>
      <p>If you continue, the wallet will be linked to this patient but cannot be moved to the Caxton trial subsidiary
        account so will remain on the main Illingworth account. </p>
      <p>Please check you have selected the correct wallet before continuing.</p>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="onContinueMoveActiveCard()" class="btn btn-primary"
            [ngClass]="{'disabled': processing}">
            <span *ngIf="processing">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </span>
            <span *ngIf="!processing">Continue</span>
          </a>
        </div>
        <div class="col-6">
          <a (click)="modal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</app-modal>